import { render, staticRenderFns } from "./facade.vue?vue&type=template&id=056221c0"
import script from "./facade.vue?vue&type=script&lang=js"
export * from "./facade.vue?vue&type=script&lang=js"
import style0 from "./facade.vue?vue&type=style&index=0&id=056221c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports